import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ReactSortable } from "react-sortablejs";
import {
    getSubscriptionDurationSagaAction,
    removeSubscriptionDurationSagaAction,
    sortSagaAction
} from "../../redux/sagaActions";

const SubscriptionDurations = () => {
    const dispatch = useDispatch();
    const subscription_durations = useSelector(state => state.subscription_durations);

    const [list, setList] = useState([]);

    // Смена позиций
    const changePositions = ({ oldInd, newInd }) => {
        // Копируем начальный массив
        let copy = [...subscription_durations];

        let cut = copy.splice(oldInd, 1)[0];
        copy.splice(newInd, 0, cut);

        dispatch(sortSagaAction({
            table: 'duration',
            new_order: JSON.stringify(copy.map(elem => elem.id))
        }));

        setList([]);
    };

    return (
        <div className="settings">
            <ReactSortable
                list={ list }
                setList={ setList }
                handle={ '.control--move' }
                onEnd={ event => changePositions({ oldInd: event.oldIndex, newInd: event.newIndex }) }
            >
                {
                    subscription_durations.map(elem => {
                        return (
                            <div className="setting" key={ elem.id }>
                                <div className="controls">
                                    <i className="control control--edit" onClick={ () => {
                                        dispatch(getSubscriptionDurationSagaAction({ id: elem.id }));
                                    } }/>
                                    <i className="control control--move" />
                                    <i className="control control--remove" onClick={ () => {
                                        if (window.confirm('Вы действительно хотите удалить этот срок действия абонемента?')) {
                                            dispatch(removeSubscriptionDurationSagaAction({ id: elem.id }));
                                        }
                                    } }/>
                                </div>
                                <div className="setting__caption">{ elem.name }</div>
                            </div>
                        );
                    })
                }
            </ReactSortable>
        </div>
    );
};

export default SubscriptionDurations;